module.exports = __webpack_public_path__ + "img/비.dde10a75.png";